module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('columns', [_c('column', {
    attrs: {
      "is-4": "",
      "is-offset-4": ""
    }
  }, [_c('box', [_c('media', [_c('media-left', [_c('b-image', {
    attrs: {
      "is-64x64": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/128x128.png",
      "alt": "Image"
    }
  })])], 1), _vm._v(" "), _c('media-content', [_c('content', [_c('p', [_c('strong', [_vm._v("John Smith")]), _vm._v(" "), _c('small', [_vm._v("@johnsmith")]), _vm._v(" "), _c('small', [_vm._v("31m")]), _vm._v(" "), _c('br'), _vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean efficitur sit amet massa fringilla egestas. Nullam condimentum luctus turpis.\n            ")])]), _vm._v(" "), _c('level', {
    attrs: {
      "is-mobile": ""
    }
  }, [_c('level-left', [_c('level-item', {
    attrs: {
      "outerElement": "a"
    }
  }, [_c('icon', {
    attrs: {
      "is-small": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })])], 1), _vm._v(" "), _c('level-item', {
    attrs: {
      "outerElement": "a"
    }
  }, [_c('icon', {
    attrs: {
      "is-small": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-retweet"
  })])], 1), _vm._v(" "), _c('level-item', {
    attrs: {
      "outerElement": "a"
    }
  }, [_c('icon', {
    attrs: {
      "is-small": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f0a9514"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/example/box.vue
// module id = 17
// module chunks = 0